module.exports = __webpack_public_path__ + "17fcc0605ccce1578bb898c287db0456.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/RoundedMplus1c-Regular.ttf
// module id = 22
// module chunks = 0